var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopBriefcase32Regular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.25 6A3.25 3.25 0 0 0 4 9.25v9.5A3.25 3.25 0 0 0 7.25 22h7.25v-2H7.25C6.56 20 6 19.44 6 18.75v-9.5C6 8.56 6.56 8 7.25 8h17.5c.69 0 1.25.56 1.25 1.25v3.285a3.5 3.5 0 0 1 2 1.015v-4.3A3.25 3.25 0 0 0 24.75 6zM3 24h11.5v2H3a1 1 0 1 1 0-2m16.5-8v1.5h-1.25a2.25 2.25 0 0 0-2.236 2H16v7.25A2.25 2.25 0 0 0 18.25 29h10.5A2.25 2.25 0 0 0 31 26.75V19.5h-.014a2.25 2.25 0 0 0-2.236-2H27.5V16a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2m2-.5h4a.5.5 0 0 1 .5.5v1.5h-5V16a.5.5 0 0 1 .5-.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopBriefcase32Regular);
export default __webpack_public_path__ + "static/media/laptop-briefcase-32-regular.9d295d175e46fafe501255502c6f73c1.svg";
export { ForwardRef as ReactComponent };